import { Pipe } from '@angular/core';
var RangePipe = (function () {
    function RangePipe() {
    }
    RangePipe.prototype.transform = function (_input, size, start, step) {
        if (size === void 0) { size = 0; }
        if (start === void 0) { start = 1; }
        if (step === void 0) { step = 1; }
        var range = [];
        for (var length_1 = 0; length_1 < size; ++length_1) {
            range.push(start);
            start += step;
        }
        return range;
    };
    return RangePipe;
}());
export { RangePipe };
RangePipe.decorators = [
    { type: Pipe, args: [{
                name: 'range'
            },] },
];
/** @nocollapse */
RangePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=range.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/range.pipe.js
// module id = 244
// module chunks = 103